import Link from "next/link";
import { useField } from "formik";
import PortableTextPlus from "@/components/portable-text-plus";
import { Filter } from "@/components/segments/hero-single-block";
import SegmentContainer from "@/components/segments/segment-container";
import InputGuideText from "@/components/input-guide-text";
import classNames from "classnames";
import { SearchSVG } from "@/components/svg";

export default function Header({ segment, ...props }) {
  return (
    <div className="relative">
      {segment.bgFilter && (
        <Filter
          fromColorHex={segment.bgFilterFromColorHex}
          toColorHex={segment.bgFilterToColorHex}
        />
      )}

      <SegmentContainer
        className={props.paddingClasses}
        style={{ ...props.bgImageStyle, ...props.bgColorStyle }}
      >
        <div
          className={classNames(
            "leading-snug text-center sm:text-left space-y-8",
            props.widthClasses
          )}
        >
          <div
            className={classNames(
              "text-2xl sm:text-3xl md:text-4xl xl:text-4.5xl font-semibold",
              "leading-snug sm:leading-snug xl:leading-tight whitespace-pre-line"
            )}
          >
            <Link href="/blog">
              <a className="hover:text-dark-purple">
                <PortableTextPlus value={segment.block.heading} />
              </a>
            </Link>
          </div>
          {/* TODO: implement in tier 2 tasks */}
          {/* <Formik
            initialValues={{ search: "" }}
            validationSchema={Yup.object({
              search: Yup.string().required("Please enter a search term"),
            })}
            onSubmit={(values, { setSubmitting }) => {
              console.log(values);
            }}
          >
            {(formik) => (
              <Form onSubmit={formik.handleSubmit}>
                <FormikBlogSearchInput name="search" placeholder="Search" />
              </Form>
            )}
          </Formik> */}
        </div>
      </SegmentContainer>
    </div>
  );
}

export const FormikBlogSearchInput = ({ className, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className="group">
      <div className="mt-1 relative rounded-xl">
        <input
          className={classNames(
            "block w-full h-12 pl-3 pr-7 py-2.5 text-gray-4",
            "text-sm rounded-xl border focus:outline-none",
            "focus:border-light-purple focus:shadow-border-focus",
            meta.touched && meta.error
              ? "border-error-red shadow-border-error"
              : "border-transparent",
            className
          )}
          ref={props.autoFocus ? inputRef : null}
          {...field}
          {...props}
        />
        <SearchSVG
          className={classNames(
            "absolute right-4 top-[calc(50%-12px)] w-[24px] h-[24px]",
            "stroke-subtext-gray group-focus-within:stroke-dark-purple"
          )}
        />
      </div>
      <InputGuideText className="min-h-[1rem] mt-0.5 ml-0.5" isWarning={true}>
        {meta.touched && meta.error ? meta.error : ""}
      </InputGuideText>
    </div>
  );
};
